 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import TOC from '@/components/toc'
 import A_CHAPTER701NEGOTIATIONS from '@/components/0_chapter701negotiations'
 import A_CHAPTER702COMPLETIONOFSECLUSION from '@/components/1_chapter702completionofseclusion'
 import A_CHAPTER703JUSTINTIME from '@/components/2_chapter703justintime'
 import A_CHAPTER704HALFYEARTIME from '@/components/3_chapter704halfyeartime'
 import A_CHAPTER705REACHINGINFINITY from '@/components/4_chapter705reachinginfinity'
 import A_CHAPTER706CITYGATEWINDWAVE from '@/components/5_chapter706citygatewindwave'
 import A_CHAPTER707SELECTIONSTART from '@/components/6_chapter707selectionstart'
 import A_CHAPTER708ENEMIESHAVEANARROWROAD from '@/components/7_chapter708enemieshaveanarrowroad'
 import A_CHAPTER709EVENLYMATCHED from '@/components/8_chapter709evenlymatched'
 import A_CHAPTER710CALLINGATTENTION from '@/components/9_chapter710callingattention'
 import A0_CHAPTER711SENDYOURSELFTOTHEDOOR from '@/components/10_chapter711sendyourselftothedoor'
 import A1_CHAPTER712ITWASJUSTATEAMANNIHILATION from '@/components/11_chapter712itwasjustateamannihilation'
 import A2_CHAPTER713ENTER1000 from '@/components/12_chapter713enter1000'
 import A3_CHAPTER714INITIALCONVERSATION from '@/components/13_chapter714initialconversation'
 import A4_CHAPTER715AGREEDSTRATEGIES from '@/components/14_chapter715agreedstrategies'
 import A5_CHAPTER716SENDDOWNWARNOTES from '@/components/15_chapter716senddownwarnotes'
 import A6_CHAPTER717PROFOUNDSEALCOMPETITION from '@/components/16_chapter717profoundsealcompetition'
 import A7_CHAPTER718MOUNTAINANDRIVERSEAL from '@/components/17_chapter718mountainandriverseal'
 import A8_CHAPTER719THEHARVESTWASPLENTIFUL from '@/components/18_chapter719theharvestwasplentiful'
 import A9_CHAPTER720FIGHTINGBETWEENTHESTRONG from '@/components/19_chapter720fightingbetweenthestrong'
 import A0_CHAPTER721KILLLEFT from '@/components/20_chapter721killleft'
 import A1_CHAPTER722ANCIENTRUNES from '@/components/21_chapter722ancientrunes'
 import A2_CHAPTER723NINTHLEAF from '@/components/22_chapter723ninthleaf'
 import A3_CHAPTER724LIGHTOFENLIGHTENMENT from '@/components/23_chapter724lightofenlightenment'
 import A4_CHAPTER725THUNDEROUSTRANSFORMATION from '@/components/24_chapter725thunderoustransformation'
 import A5_CHAPTER726KINGSOVEREIGNAPPEARED from '@/components/25_chapter726kingsovereignappeared'
 import A6_CHAPTER727EVERYONEBREAKTHROUGH from '@/components/26_chapter727everyonebreakthrough'
 import A7_CHAPTER728FIGHTTOTHEDEATH from '@/components/27_chapter728fighttothedeath'
 import A8_CHAPTER729HAVEYOUHADENOUGH from '@/components/28_chapter729haveyouhadenough'
 import A9_CHAPTER730KILLINGTHEKINGSOVEREIGN from '@/components/29_chapter730killingthekingsovereign'
 import A0_CHAPTER731HANDLINGOFPOSTMORTEMMATTERS from '@/components/30_chapter731handlingofpostmortemmatters'
 import A1_CHAPTER732CENTRALZONE from '@/components/31_chapter732centralzone'
 import A2_CHAPTER733TENSTONEPLATFORMS from '@/components/32_chapter733tenstoneplatforms'
 import A3_CHAPTER734CRUELTYTOFIGHT from '@/components/33_chapter734crueltytofight'
 import A4_CHAPTER735ASCENDTHESTONEPLATFORM from '@/components/34_chapter735ascendthestoneplatform'
 import A5_CHAPTER736DIRECTLYFACINGKINGSOVEREIGN from '@/components/35_chapter736directlyfacingkingsovereign'
 import A6_CHAPTER737AGAINCUTTINGKINGSOVEREIGN from '@/components/36_chapter737againcuttingkingsovereign'
 import A7_CHAPTER738THOUSANDS from '@/components/37_chapter738thousands'
 import A8_CHAPTER739COMPETITIONFORTHETOP1001 from '@/components/38_chapter739competitionforthetop1001'
 import A9_CHAPTER740COMPETITIONFORTHETOP1002 from '@/components/39_chapter740competitionforthetop1002'
 import A0_CHAPTER741COMPETITIONFORTHETOP1003 from '@/components/40_chapter741competitionforthetop1003'
 import A1_CHAPTER742COMPETITIONFORTHETOP1004 from '@/components/41_chapter742competitionforthetop1004'
 import A2_CHAPTER743COMPETITIONFORTHETOP1005 from '@/components/42_chapter743competitionforthetop1005'
 import A3_CHAPTER744RETREATWITHOUTAFIGHT from '@/components/43_chapter744retreatwithoutafight'
 import A4_CHAPTER745FINALWARI from '@/components/44_chapter745finalwari'
 import A5_CHAPTER746FINALWARII from '@/components/45_chapter746finalwarii'
 import A6_CHAPTER747FINALWARIII from '@/components/46_chapter747finalwariii'
 import A7_CHAPTER748FINALBATTLE4 from '@/components/47_chapter748finalbattle4'
 import A8_CHAPTER749FINALWARV from '@/components/48_chapter749finalwarv'
 import A9_CHAPTER750WARSEALCONTESTI from '@/components/49_chapter750warsealcontesti'
 import A0_CHAPTER751WARSEALCONTEST2 from '@/components/50_chapter751warsealcontest2'
 import A1_CHAPTER752WAROFTHEWARSEALCONTEST3 from '@/components/51_chapter752warofthewarsealcontest3'
 import A2_CHAPTER753WARSEALCONTEST4 from '@/components/52_chapter753warsealcontest4'
 import A3_CHAPTER754WARSEALCONTEST5 from '@/components/53_chapter754warsealcontest5'
 import A4_CHAPTER755CARDIACARRAYILLUSORYDRAGONARRAY from '@/components/54_chapter755cardiacarrayillusorydragonarray'
 import A5_CHAPTER756AFEWMORE from '@/components/55_chapter756afewmore'
 import A6_CHAPTER757FIGHTAGAINSTQINTIAN from '@/components/56_chapter757fightagainstqintian'
 import A7_CHAPTER758EVENLYMATCHED from '@/components/57_chapter758evenlymatched'
 import A8_CHAPTER759STILLNESSINBATTLE from '@/components/58_chapter759stillnessinbattle'
 import A9_CHAPTER760ENDOFCOMPETITION from '@/components/59_chapter760endofcompetition'
 import A0_CHAPTER761FIVEIMMORTALARTIFACTS from '@/components/60_chapter761fiveimmortalartifacts'
 import A1_CHAPTER762SUPREMEDHARMABODY from '@/components/61_chapter762supremedharmabody'
 import A2_CHAPTER763QINTIANJOINED from '@/components/62_chapter763qintianjoined'
 import A3_CHAPTER764ONHISWAYHOME from '@/components/63_chapter764onhiswayhome'
 import A4_CHAPTER765ASTRONGSOUTHERNPREFECTURE from '@/components/64_chapter765astrongsouthernprefecture'
 import A5_CHAPTER766MAFAMILY from '@/components/65_chapter766mafamily'
 import A6_CHAPTER767GOODBYETOSUTONG from '@/components/66_chapter767goodbyetosutong'
 import A7_CHAPTER768ONHISWAYTOTHELOSTLAND from '@/components/67_chapter768onhiswaytothelostland'
 import A8_CHAPTER769SEETHEOLDMAN from '@/components/68_chapter769seetheoldman'
 import A9_CHAPTER770RETURNTOTIANLUO from '@/components/69_chapter770returntotianluo'
 import A0_CHAPTER771SOUTHERNPREFECTURECORRECTION from '@/components/70_chapter771southernprefecturecorrection'
 import A1_CHAPTER772DEMONESSFROMTHEDEMONRACE from '@/components/71_chapter772demonessfromthedemonrace'
 import A2_CHAPTER773WHEREDIDYOUCOMEFROMGOBACKTOWHERE from '@/components/72_chapter773wheredidyoucomefromgobacktowhere'
 import A3_CHAPTER774APOLOGIZEORDIE from '@/components/73_chapter774apologizeordie'
 import A4_CHAPTER775DEMONLORDSCLONE from '@/components/74_chapter775demonlordsclone'
 import A5_CHAPTER776DEMONSANDEVILS from '@/components/75_chapter776demonsandevils'
 import A6_CHAPTER777TWOPEOPLETRANSCENDINGTRIBULATION from '@/components/76_chapter777twopeopletranscendingtribulation'
 import A7_CHAPTER778NEWLYADDEDHAND from '@/components/77_chapter778newlyaddedhand'
 import A8_CHAPTER779DEMONMOVEMENT from '@/components/78_chapter779demonmovement'
 import A9_CHAPTER780SECLUSIONAGAIN from '@/components/79_chapter780seclusionagain'
 import A0_CHAPTER781CRANEDESCENDANT from '@/components/80_chapter781cranedescendant'
 import A1_CHAPTER782IMPACTFAILURE from '@/components/81_chapter782impactfailure'
 import A2_CHAPTER783DESOLATESWAMP from '@/components/82_chapter783desolateswamp'
 import A3_CHAPTER784ENTERINGDESOLATESWAMP from '@/components/83_chapter784enteringdesolateswamp'
 import A4_CHAPTER785CRANECLAN from '@/components/84_chapter785craneclan'
 import A5_CHAPTER786LEAVINGTHEDESOLATESWAMP from '@/components/85_chapter786leavingthedesolateswamp'
 import A6_CHAPTER787CHIEFOFTHECRANECLAN from '@/components/86_chapter787chiefofthecraneclan'
 import A7_CHAPTER788SOARINGSNAKES from '@/components/87_chapter788soaringsnakes'
 import A8_CHAPTER789HERBATETRANDRAE from '@/components/88_chapter789herbatetrandrae'
 import A9_CHAPTER790LEAVINGTHECRANECLAN from '@/components/89_chapter790leavingthecraneclan'
 import A0_CHAPTER791THETWOLITTLEGUYSAREBACK from '@/components/90_chapter791thetwolittleguysareback'
 import A1_CHAPTER792PEOPLESMEETING from '@/components/91_chapter792peoplesmeeting'
 import A2_CHAPTER793LINFANSACCIDENT from '@/components/92_chapter793linfansaccident'
 import A3_CHAPTER794QINGYUNSECTEXTERMINATED from '@/components/93_chapter794qingyunsectexterminated'
 import A4_CHAPTER795DEMONBLACKHAND from '@/components/94_chapter795demonblackhand'
 import A5_CHAPTER796TOKILLTHEDEMONS from '@/components/95_chapter796tokillthedemons'
 import A6_CHAPTER797DECISIVEACTION from '@/components/96_chapter797decisiveaction'
 import A7_CHAPTER798FIGHTINGAGAINSTTHEDEMONLORD from '@/components/97_chapter798fightingagainstthedemonlord'
 import A8_CHAPTER799THEDEMONGODKOWTOWED from '@/components/98_chapter799thedemongodkowtowed'
 import A9_CHAPTER800FIGHTTOTHEDEATH from '@/components/99_chapter800fighttothedeath'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/toc",
 			"name" : "toc",
 			"component" : TOC
 		},
 		{
 			"path" : "/0_chapter701negotiations",
 			"name" : "0_chapter701negotiations",
 			"component" : A_CHAPTER701NEGOTIATIONS
 		},
 		{
 			"path" : "/1_chapter702completionofseclusion",
 			"name" : "1_chapter702completionofseclusion",
 			"component" : A_CHAPTER702COMPLETIONOFSECLUSION
 		},
 		{
 			"path" : "/2_chapter703justintime",
 			"name" : "2_chapter703justintime",
 			"component" : A_CHAPTER703JUSTINTIME
 		},
 		{
 			"path" : "/3_chapter704halfyeartime",
 			"name" : "3_chapter704halfyeartime",
 			"component" : A_CHAPTER704HALFYEARTIME
 		},
 		{
 			"path" : "/4_chapter705reachinginfinity",
 			"name" : "4_chapter705reachinginfinity",
 			"component" : A_CHAPTER705REACHINGINFINITY
 		},
 		{
 			"path" : "/5_chapter706citygatewindwave",
 			"name" : "5_chapter706citygatewindwave",
 			"component" : A_CHAPTER706CITYGATEWINDWAVE
 		},
 		{
 			"path" : "/6_chapter707selectionstart",
 			"name" : "6_chapter707selectionstart",
 			"component" : A_CHAPTER707SELECTIONSTART
 		},
 		{
 			"path" : "/7_chapter708enemieshaveanarrowroad",
 			"name" : "7_chapter708enemieshaveanarrowroad",
 			"component" : A_CHAPTER708ENEMIESHAVEANARROWROAD
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js